﻿import $ from 'jquery';
import Humanizer from "humanize-plus";

import { MultiSelectTable } from "./multiselecttable"
import Url from "../utilities/url";

$(function () {

  let getUrlAttribute = function ($element: JQuery): string {
    if ($element.is('[href]'))
      return 'href'
    else if ($element.is('[data-url]'))
      return 'data-url';
    else if ($element.is('[data-documentlink]'))
      return 'data-documentlink';
    else
      throw new Error('Does not have a valid url.')
  }

  let isDisabledKey = 'rustig.multiselectcontextmenuitem.isDisabled';

  let addIdsToUrl = function ($element: JQuery, selected: number[]) {
    let href = getUrlAttribute($element);
    let queryParameterName = $element.data('actionmenu-multiselect-query-parameter') || 'ids';
    let url = new Url($element.attr(href))
      .setQueryParameter(queryParameterName, selected.map(x => x.toString()));
    $element.attr(href, url.toUrl());
  }

  $(document).on('show.rustig.popover', 'table.multiselect [data-popover]', function (e) {
    e.stopImmediatePropagation();
    let $popover = $(this);
    let table = <MultiSelectTable>$popover.closest('table.multiselect').data('rustig.multiselecttable');

    let $row = $popover.closest('tr');
    if (!table.isRowSelected($row))
      table.selectRowElement($row);

    let selected = <Array<number>>table.selected();

    let $popoverContent = $('popover-content'.asDataSelector($popover.data('popover')));
    $popoverContent.find('li a').each(function () {
      let $element = $(this);
      let isDisabled = $element.isDisabled();
      $element.data(isDisabledKey, isDisabled);

      if (isDisabled || !$element.is('[data-actionmenu-multiselect]')) {
        if (selected.length > 1)
          $element.disable();
        return;
      }

      addIdsToUrl($element, selected);
    });
    //$popoverContent.find('.actionmenu').prepend($('<li class="actionmenu-header">' + ' item'.toQuantity(selected.length, Humanizer.ShowQuantityAs.Numeric) + ' selected</li>'));
    $popoverContent.find('.actionmenu').prepend($('<li class="actionmenu-header">' + selected.length + Humanizer.pluralize(selected.length, ' item') + ' selected</li>'));
  });

  let tryEnable = function ($element: JQuery) {
    let wasDisabledByThisPlugin = $element.data(isDisabledKey) != null && $element.data(isDisabledKey) == false
    if (wasDisabledByThisPlugin)
      $element.enable();
  }

  let removeIdsFromUrl = function ($element: JQuery) {
    let href = getUrlAttribute($element);
    let queryParameterName = $element.data('multiselect-query-parameter') || 'ids';
    let url = new Url($element.attr(href))
      .removeQueryParameter(queryParameterName);
    $element.attr(href, url.toUrl());
  }

  $(document).on('hide.rustig.popover', 'table.multiselect [data-popover]', function () {
    let $popover = $(this);

    let $content = $('popover-content'.asDataSelector($popover.data('popover')));
    $content.find('li a').each(function () {
      let $element = $(this);

      tryEnable($element);

      if ($element.is('[data-actionmenu-multiselect]'))
        removeIdsFromUrl($element);
    });
    $content.find('.actionmenu-header').remove();
  });
});